module.exports = __webpack_public_path__ + "assets/assets/images/intake/f2f-characters.a1b7cee3.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/intake/f2f-characters.png
// module id = 394
// module chunks = 0